import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { SocialHabitsApi } from '../api/socialhabits.api';
import { switchMap, map } from 'rxjs/operators';

import { SocialHabits,SocialHabitsData } from '../../../interfaces/masters/socialhabits';
@Injectable() 
export class SocialHabitsService extends SocialHabitsData{

  constructor(private api: SocialHabitsApi) {
    super();
  } 
  
  list(url: string): Observable<SocialHabits[]> { 
    return this.api.list(url);
  } 

  getById(url:string): Observable<SocialHabits>{
      return this.api.getById(url);
  }

  create(url: string, data:SocialHabits): Observable<SocialHabits[]> {
    return this.api.add(url,data);
  }

  update(url: string, data:SocialHabits): Observable<SocialHabits> { 
    return this.api.update(url,data);
  }  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
